import { ICONS } from '@client/constants/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/claims')({
    staticData: {
        breadcrumb: {
            title: 'Claims',
        },
        ui: {
            icon: ICONS.claim,
        },
        roles: ['user', 'shared_edit_user', 'org_admin'],
        modules: ['claim'],
    },
    component: Outlet,
});
